<template>
  <div class="mb-2">
    <v-slide-y-transition>
      <div v-show="!value.isPDFGenerated">
        <v-btn
          v-show="!value.isGenerating"
          @click="genPDFOnClick"
        >
          {{ $t('Outbox.GenUploadFile') }}
        </v-btn>

        <v-slide-y-transition>
          <v-card
            v-show="value.isGenerating"
            max-width="500"
            elevation="12"
            class="mx-auto my-10"
          >
            <v-card-title class="py-6 text-center">
              {{ $t('Outbox.GeneratingUploadFile') }}
              <v-progress-linear
                indeterminate
                height="8"
                color="primary"
              />
            </v-card-title>
          </v-card>
        </v-slide-y-transition>
      </div>
    </v-slide-y-transition>

    <v-slide-y-transition>
      <div v-show="value.isPDFGenerated">
        <v-btn
          class="mr-2"
          @click="previewOficioFileList"
        >
          {{ $t('Outbox.PreviewUploadFile') }}
        </v-btn>
        <v-btn
          v-if="value.refResponse && value.refResponse.length"
          @click="previewRefFileList"
        >
          {{ $t('Outbox.PreviewRefDoc') }}
        </v-btn>
        <!-- <s-show-img
        v-model="dialog"
        :files="files"
      /> -->
        <s-class-pdf-muti
          v-model="dialog"
          :file-ctxs="files"
        />
        <br><br>
        <v-autocomplete
          v-model="local.issueSubunitEntityId"
          :items="issueSubunitEntity"
          item-value="id"
          :item-text="item => item.abbr + '-' + $chPtObjData('chinName', item)"
          hide-details
          :label="$t('Outbox.IssueSubunitEntity')"
        />
        <br><br>
        <s-search-staff
          :select.sync="local.nextStaff"
          :staff.sync="local.nextStaffObj"
          :label="$t('Outbox.NextStaff')"
          show-support-staff
          show-group
        />
        <!-- <v-switch
          v-model="local.isUrgent"
          :label="$t('Outbox.Urgent')"
          class="d-inline-block"
        /> -->

        <br>
        <v-btn
          color="primary"
          :loading="loading"
          @click="insertNewOficio"
        >
          {{ $t('Outbox.Present') }}
        </v-btn>
      </div>
    </v-slide-y-transition>
  </div>
</template>

<script>
import SSearchStaff from '@/components/SSearchStaff'
import SClassPdfMuti from '@/components/SClassPdfMuti'
// import SShowImg from '@/components/SShowImg'
import outboxApi from '@/api/outbox/outbox'
import pdfApi from '@/api/tools/pdf'
import esignApi from '@/api/outbox/sign'
import { globalModule } from '@/store/moduleName'
import { filename, fileExt } from '@/utils/stringUtil'
import { OUTBOX_ENTITY_SOURCE_TYPE, OUTBOX_FILE_TYPE, OUTBOX_REPLY_DOC_CNT } from '@/constant/constant'
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
import { getArraySorter } from '@/utils/arrayUtil'

function getEntityIdStr (selectedEntities) {
  let entityIds = []
  selectedEntities.forEach(element => {
    entityIds.push(element.split('-')[1])
  })
  return entityIds.join()
}

function getIssueSubunitEntity (inst) {
  outboxApi.getIssueSubunitEntity(resp => {
    if (resp.status === 201 || resp.status === 200) {
      inst.issueSubunitEntity = resp.data
      inst.issueSubunitEntity.some(subEntity => {
        if (subEntity.isDefault) {
          inst.value.issueSubunitEntityId = subEntity.id
          return true
        }
      })
    }
  })
}

export default {
  components: {
    SClassPdfMuti,
    // SShowImg,
    SSearchStaff
  },
  props: {
    value: {
      type: Object,
      default: null
      // {
      //   ...
      //   nextStaff
      // },
    }
  },
  data: () => {
    return {
      loading: false,
      dialog: false,
      // displayFile: null,
      fileStream: null,
      files: [],
      issueSubunitEntity: []
    }
  },
  computed: {
    local () {
      return this.value ? this.value : {
        nextStaff: null
        // isUrgent: false
      }
    }
  },
  watch: {
    // displayFile: function (val) {
    //   outboxApi.downloadFile(val.documentCode, val.uploadFileId, resp => {
    //     if (resp.status === 201 || resp.status === 200) {
    //       this.fileStream = resp.data
    //     }
    //   })
    // }
  },
  created () {
    getIssueSubunitEntity(this)
  },
  methods: {
    update (key, value) {
      this.value.nextStaff = value
      // this.$emit('input', { ...this.local, [key]: value })
    },
    getSendDate () {
      let sendDates = null
      if (this.value.watchProps.isReply) {
        sendDates = []
        for (let i = 0; i < OUTBOX_REPLY_DOC_CNT; i++) {
          if (this.value.watchProps.sendDate[i]) {
            sendDates.push(this.value.watchProps.sendDate[i])
          } else if (!this.value.watchProps.sendDate[i] && this.value.watchProps.senderOficioNo[i]) {
            sendDates.push('')
          }
        }
      }
      return sendDates
    },
    getSenderOficioNo () {
      let senderOficioNos = null
      if (this.value.watchProps.isReply) {
        senderOficioNos = []
        for (let i = 0; i < OUTBOX_REPLY_DOC_CNT; i++) {
          if (this.value.watchProps.senderOficioNo[i]) {
            senderOficioNos.push(this.value.watchProps.senderOficioNo[i])
          } else if (!this.value.watchProps.senderOficioNo[i] && this.value.watchProps.sendDate[i]) {
            senderOficioNos.push('')
          }
        }
      }
      return senderOficioNos
    },
    genPDFOnClick () {
      if (this.value.watchProps.oficioDocResponse.length === 0) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsUpload', [this.$t('Outbox.doc')]))
        return false
      }

      if (fileExt(this.value.watchProps.oficioDocResponse[0].name).toLowerCase() === 'pdf') {
        this.checkPDF()
      } else {
        this.genPDF()
      }
    },
    checkPDF () {
      if (!this.value.signer) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsSelect', [this.$t('Outbox.Signer')]))
        return false
      }
      this.value.isGenerating = true

      pdfApi.checkSignatureFieldExists(this.value.watchProps.oficioDocResponse[0].response.instanceCode, 'signature-1', resp => {
        this.value.isGenerating = false
        if (resp.status === 201 || resp.status === 200) {
          if (resp.data) {
            this.value.oficioPdfResponse = []
            let pdfResp = {
              id: this.value.watchProps.oficioDocResponse[0].response.id,
              instanceCode: this.value.watchProps.oficioDocResponse[0].response.instanceCode,
              entityId: 0
            }
            this.value.oficioPdfResponse.push(pdfResp)
            this.value.isPDFGenerated = true
            this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Outbox.GenUploadFile.Success'))
          } else {
            this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Outbox.Error.DocNoSignField'))
          }
        }
      })
    },
    genPDF () {
      if (!this.value.watchProps.docNo) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('Outbox.number')]))
        return false
      }
      if (this.value.watchProps.selectedEntities.length === 0) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsSelect', [this.$t('Outbox.ReceiveDept')]))
        return false
      }
      if (this.value.watchProps.oficioDocResponse.length === 0) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsUpload', [this.$t('Outbox.doc')]))
        return false
      }
      if (!this.value.title) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('eDocInternal.subject')]))
        return false
      }
      if (!this.value.signer) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsSelect', [this.$t('Outbox.Signer')]))
        return false
      }
      this.value.isGenerating = true

      let mergeAttachments = []
      for (let i = 0; i < this.value.watchProps.mergePdfResponse.length; i++) {
        const resp = this.value.watchProps.mergePdfResponse[i]
        mergeAttachments.push({
          instanceCode: resp.response.instanceCode,
          uploadFileId: resp.response.id
        })
      }
      outboxApi.mailMergeOficioPDF_v2(this.value.issueEntityId, '', getEntityIdStr(this.value.watchProps.selectedEntities), OUTBOX_ENTITY_SOURCE_TYPE.APM,
        this.value.watchProps.oficioDocResponse[0].response.instanceCode, this.value.watchProps.labelTypeId, this.value.watchProps.docNo,
        this.value.watchProps.oficioDocResponse[0].response.id, this.getSendDate(), this.getSenderOficioNo(), mergeAttachments, resp => {
          this.value.isGenerating = false
          if (resp.status === 201 || resp.status === 200) {
            this.value.oficioPdfResponse = resp.data
            this.value.isPDFGenerated = true
            this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Outbox.GenUploadFile.Success'))
          }
        })
    },
    insertNewOficio () {
      if (!this.value.watchProps.docNo) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('Outbox.number')]))
        return false
      }
      if (!this.value.title) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('eDocInternal.subject')]))
        return false
      }
      // if ((this.value.issueEntities.length > 0) && (this.value.issueEntityId === null)) {
      //   this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsSelect', [this.$t('Outbox.IssueEntity')]))
      //   return false
      // }
      if (!this.value.signer) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsSelect', [this.$t('Outbox.Signer')]))
        return false
      }
      if (!this.value.issueSubunitEntityId) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsSelect', [this.$t('Outbox.IssueSubunitEntity')]))
        return false
      }
      if (!this.value.nextStaff) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsSelect', [this.$t('Outbox.NextStaff')]))
        return false
      }

      let attachments = []
      for (let i = 0; i < this.value.attachResponse.length; i++) {
        const resp = this.value.attachResponse[i]
        attachments.push({
          displayName: filename(resp.name),
          entityId: resp.response.entityId,
          entitySourceTypeId: 1,
          fileExtension: fileExt(resp.name),
          instanceCode: resp.response.instanceCode,
          uploadFileId: resp.response.id
        })
      }

      let oficios = []
      let oficioDocFilename = filename(this.value.watchProps.oficioDocResponse[0].name)
      for (let i = 0; i < this.value.oficioPdfResponse.length; i++) {
        const resp = this.value.oficioPdfResponse[i]
        oficios.push({
          displayName: oficioDocFilename,
          entityId: resp.entityId,
          entitySourceTypeId: 1,
          fileExtension: 'pdf',
          instanceCode: resp.instanceCode,
          uploadFileId: resp.id
        })
      }

      let references = []
      for (let i = 0; i < this.value.refResponse.length; i++) {
        const resp = this.value.refResponse[i]
        references.push({
          displayName: filename(resp.name),
          fileExtension: fileExt(resp.name),
          instanceCode: resp.response.instanceCode,
          uploadFileId: resp.response.id
        })
      }

      let mergeAttachments = []
      for (let i = 0; i < this.value.watchProps.mergePdfResponse.length; i++) {
        const resp = this.value.watchProps.mergePdfResponse[i]
        mergeAttachments.push({
          instanceCode: resp.response.instanceCode,
          uploadFileId: resp.response.id
        })
      }

      let oficioDocFileExt = fileExt(this.value.watchProps.oficioDocResponse[0].name)
      let data = {
        attachments: attachments,
        // isUrgent: this.value.isUrgent,
        isDirectSendToEDocX: this.value.isDirectSendToEDocX,
        labelTypeId: this.value.watchProps.labelTypeId,
        oficioDocDisplayName: oficioDocFilename,
        oficioDocFileExtension: oficioDocFileExt,
        oficioDocInstanceCode: this.value.watchProps.oficioDocResponse[0].response.instanceCode,
        oficioDocUploadFileId: this.value.watchProps.oficioDocResponse[0].response.id,
        oficioTypeId: this.value.docTypesId,
        oficios: oficios,
        mergeAttachments: mergeAttachments,
        refDocNo: this.value.watchProps.docNo,
        references: references,
        replyDate: this.getSendDate(),
        replyRefDocNo: this.getSenderOficioNo(),
        signer: this.value.signer,
        title: this.value.title,
        issueSubunitEntityId: this.value.issueSubunitEntityId
      }
      // if (this.value.nextStaffObj.recordType && (this.value.nextStaffObj.recordType === SEARCH_STAFF_RECORD_TYPE.GROUP)) {
      if (this.value.nextStaff && !this.value.nextStaff.startsWith('E')) {
        data.handlerGroupId = this.value.nextStaff
      } else {
        data.handler = this.value.nextStaff
      }
      if (this.value.issueEntities.length > 0) {
        data.issueEntityId = this.value.issueEntityId
      }
      if (this.value.watchProps.ccEntities.length > 0) {
        data.carbonCopyEntities = []
        this.value.watchProps.ccEntities.forEach(ccEntityId => {
          data.carbonCopyEntities.push({
            entityId: ccEntityId,
            entitySourceTypeId: 1
          })
        })
      }
      this.loading = true
      esignApi.insertNewOficio_v2(data, resp => {
        this.loading = false
        if (resp.status === 201 || resp.status === 200) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Outbox.Upload.Success'))
          this.$emit('uploadSuccess')
        }
      })
    },
    // preview files not yet in task list
    previewFileList (data) {
      outboxApi.previewOficioFileList(data, resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.files = []
          let respData = resp.data
          respData.sort(getArraySorter('listOrder', true))
          for (let i = 0; i < respData.length; i++) {
            const e = respData[i]
            let pdfInitParams = {
              url: this.$config.apiDomain.ALI + '/ext/ga/core-util-outbox/outbox/api/downloadFile?instanceCode=' + e.documentCode + '&uploadFileId=' + e.uploadFileId,
              httpHeaders: { Authorization: 'Bearer ' + this.$g2eOauth.token },
              withCredentials: true,
              CMapReaderFactory
            }
            e.url = pdfInitParams
            this.files.push(e)
          }
          this.dialog = true
        }
      })
    },
    // preview files not yet in task list
    previewRefFileList () {
      let references = []
      for (let i = 0; i < this.value.refResponse.length; i++) {
        const resp = this.value.refResponse[i]
        references.push({
          entityId: resp.response.entityId,
          entitySourceTypeId: 1,
          fileExtension: fileExt(resp.name),
          fileTypeId: OUTBOX_FILE_TYPE.REFERENCE,
          instanceCode: resp.response.instanceCode,
          title: filename(resp.name),
          uploadFileId: resp.response.id
        })
      }

      this.previewFileList(references)
    },
    // preview files not yet in task list
    previewOficioFileList () {
      let oficios = []
      let oficioDocFilename = filename(this.value.watchProps.oficioDocResponse[0].name)
      for (let i = 0; i < this.value.oficioPdfResponse.length; i++) {
        const resp = this.value.oficioPdfResponse[i]
        oficios.push({
          entityId: resp.entityId,
          entitySourceTypeId: 1,
          fileExtension: 'pdf',
          fileTypeId: OUTBOX_FILE_TYPE.OFICIO,
          instanceCode: resp.instanceCode,
          title: oficioDocFilename,
          uploadFileId: resp.id
        })
      }

      let attachments = []
      for (let i = 0; i < this.value.attachResponse.length; i++) {
        const resp = this.value.attachResponse[i]
        attachments.push({
          entityId: resp.response.entityId,
          entitySourceTypeId: 1,
          fileExtension: fileExt(resp.name),
          fileTypeId: OUTBOX_FILE_TYPE.ATTACHMENT,
          instanceCode: resp.response.instanceCode,
          title: filename(resp.name),
          uploadFileId: resp.response.id
        })
      }

      let data = [...oficios, ...attachments]
      this.previewFileList(data)
    }
  }
}
</script>
